export enum OrderByKeys {
	RANK = 'rank',
	TOKEN = 'token_id',
	REWARDS = 'rewards',
	PRICE = 'price',
}
